import { makeStyles } from '@mui/styles';
import { neutral7 } from 'apollo-react/colors';
import Modal from 'apollo-react/components/Modal';
import Table from 'apollo-react/components/Table';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import {
  CLOSE_PARENTHESIS,
  LOGICAL_OPERATORS,
  OPEN_PARENTHESIS,
  SQL_DICTIONARY,
} from '../../constants/editor.constants';

const useStyles = makeStyles({
  modal: {
    minWidth: '80%',

    root: {
      overflow: 'hidden',
      '& [class*="Table-tableWrapper"]': {
        border: 'solid 1px #e9e9e9',
        overflow: 'hidden',
      },
      '& [class*="MuiToolbar-root"]': {
        display: 'flex',
        justifyContent: 'flex-start',
      },
      '& [class*="MuiToolbar-root"] div': {
        paddingRight: 20,
      },
      '& [class*="MuiTableHead-root"]': {
        border: 'solid 1px #e9e9e9',
        boxShadow: 'none',
      },
      '& [class*="MuiTable-root"]': {
        border: 'solid 1px #e9e9e9',
        boxShadow: 'none',
      },
      '& [class*="InternalTableBody-editMode"]': {
        backgroundColor: 'white',
        borderTop: 'none !important',
        borderBottom: 'none !important',
      },
      '& [class*="EmptyRow-middleAlign"]': {
        height: '90px !important',
      },
      '& [class*="EmptyRow-root"]': {
        border: 'solid 1px #e9e9e9',
        boxShadow: 'none',
        minHeight: '239px',
      },
      '& [class*="MuiFormControl-marginNormal"]': {
        marginTop: '0px',
      },
    },
  },
});

const customTableColumn = (options) => ({ row, column: { accessor: key } }) => {
  const providedValue = () => {
    // provide value to column by default
    let value = row[key] ?? '';

    // condition for providing correct value in rule section mapping modal
    if (row[key] && key === 'DummyFrom') {
      value = `${row[key]} (${row.From})`;
    }

    // condition for providing translated value in rule section condition modal
    if (row[key] && key === 'OpenGroup') {
      value = '(';
    } else if (row[key] && key === 'CloseGroup') {
      value = ')';
    } else if (options) {
      value = options[row[key]] ?? '';
    }

    return value;
  };
  return (
    <Typography variant="body2" style={{ color: neutral7 }}>
      {providedValue()}
    </Typography>
  );
};

const columns = [
  {
    header: '(',
    accessor: 'OpenGroup',
    customCell: customTableColumn(OPEN_PARENTHESIS),
    width: 80,
  },
  {
    header: 'LeftValue',
    accessor: 'LeftValue',
    customCell: customTableColumn(),
  },
  {
    header: 'SQL Operator',
    accessor: 'SqlOperator',
    customCell: customTableColumn(SQL_DICTIONARY),
  },
  {
    header: 'RightValue',
    accessor: 'RightValue',
    customCell: customTableColumn(),
  },
  {
    header: ')',
    accessor: 'CloseGroup',
    customCell: customTableColumn(CLOSE_PARENTHESIS),
    width: 80,
  },
  {
    header: 'Operator',
    accessor: 'RelationalOperator',
    customCell: customTableColumn(LOGICAL_OPERATORS),
  },
];

const mappingColumns = [
  {
    header: 'To',
    accessor: 'DummyTo',
    customCell: customTableColumn(),
  },
  {
    header: 'From',
    accessor: 'DummyFrom',
    customCell: customTableColumn(),
  },
];

export const RuleSectionModal = ({ modalType, rows, open, onCloseHandler, modalTitle }) => {
  const classes = useStyles();
  return (
    <Modal
      open={open}
      variant="default"
      className={classes.modal}
      onClose={() => onCloseHandler(false)}
      title={modalTitle.translatedControlName}
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={[{ label: 'Cancel', onClick: () => onCloseHandler(false) }]}
    >
      <Table
        title={modalTitle.header}
        columns={modalType !== 'mapping' ? columns : mappingColumns}
        rows={rows}
        initialSortOrder="asc"
        hidePagination
      />
    </Modal>
  );
};
